import baseApi from '../../../api/baseApi';
import startupConfig from '../../../config/startupConfig';

const get = (urlPart) => {
  const config = startupConfig.get();
  const baseUrl = config?.registrationServiceUrl ?? '';
  return baseApi.get(`${baseUrl}/api/${urlPart}`);
};

export const getAccountContactRelationsApi = async (referralCode) => {
  return get(`accountcontactrelations/referral-code/${referralCode}`);
};
